import * as Sentry from '@sentry/react';
import React, { type ReactNode, type ErrorInfo } from 'react';
import { WEB_VERSION } from '../version';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    Sentry.captureReactException(error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="px-3 py-10">
          <div
            className={
              'bg-white border border-up-black-20 rounded-lg p-3 max-w-[768px] mx-auto'
            }>
            <p className="text-up-red-50 font-bold">{this.state.error?.name}</p>
            <p className="my-2">
              Something went wrong. Please try again later.
            </p>
            <p className="text-up-black-50 text-sm">
              Ref: {this.state.error?.message}
            </p>
          </div>
          <p className="text-sm text-up-black-50 mb-10 mt-5 font-bold w-full text-center">
            v {WEB_VERSION}
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}
